import dayjs, { type ConfigType, type Dayjs } from 'dayjs';

const get7PreviousDays = (day: Dayjs): Dayjs[] => [
  day.subtract(6, 'day'),
  day.subtract(5, 'day'),
  day.subtract(4, 'day'),
  day.subtract(3, 'day'),
  day.subtract(2, 'day'),
  day.subtract(1, 'day'),
  day,
];

export const getDaysCenterOnDay = (day: Dayjs): Dayjs[] =>
  get7PreviousDays(day.add(3, 'day'));

export const formatShortDate = (
  dateString: string,
  locale: string = 'en',
): string => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
};

export const formatDayMonth = (date: string | Date): string => {
  return dayjs(date).format('D MMM').replace('.', '');
};

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export const parseDayKey = (dateString: string): Date =>
  DATE_ONLY.test(dateString)
    ? new Date(
        Number(dateString.slice(0, 4)),
        Number(dateString.slice(5, 7)) - 1,
        Number(dateString.slice(8, 10)),
      )
    : new Date(dateString);

export const formatLongDate = (
  dateString: string,
  locale: string = 'en',
): string => {
  const date = parseDayKey(dateString);
  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
};

const DAY_KEY_FORMAT = 'YYYY-MM-DD';

export const toDayKey = (day: ConfigType = dayjs()): string =>
  dayjs(day).format(DAY_KEY_FORMAT);
